import React from "react";
import { DropdownItemProps } from "semantic-ui-react";

interface ContextType {
  options: Options;
  filters: Filters;
}

interface Options {
  states: DropdownItemProps[];
  districts: DropdownItemProps[];
  user: DropdownItemProps[];
  userRoles: DropdownItemProps[];
}

interface Filters {
  AllDistrictS: DropdownItemProps[];
  reportee: any[];
  setReportee(reportee: any[]): void;

  setDistrictOptions: React.Dispatch<
    React.SetStateAction<DropdownItemProps[]>
  >;

  states: string;
  setStates(states: string): void;

  district: string;
  setDistrict(district: string): void;

  user: string;
  setUser(user: string): void;

  claimNumber: string;
  setClaimNumber(claimNumber: string): void;

  userRole: string;
  setUserRole(userRole: string): void;
}

const HomePageContext = React.createContext({} as ContextType);

export default HomePageContext;